module.exports = __webpack_public_path__ + "img/Aspect_Distribution_Map.e36eab80.jpg";